'use client';

import { useEffect, useState } from 'react';

export function useHash(): string {
  const [hash, setHash] = useState(() =>
    typeof window !== 'undefined' ? window.location.hash.replace('#', '') : '',
  );

  useEffect(() => {
    const onHashChange = () => {
      setHash(window.location.hash.replace('#', ''));
    };

    window.addEventListener('hashchange', onHashChange);
    // Sync on mount in case SSR value differs
    onHashChange();

    return () => {
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);

  return hash;
}
